import Loadable from "react-loadable";

export const CreateCompanyModal = Loadable({
  loader: () => import("../../../modules/create-company").then((module) => module.CreateCompanyModal) as Promise<any>,
  loading: () => null,
});
